export const CURRENCY_USD = 'USD';
export const CURRENCY_EUR = 'EUR';
export const CURRENCY_JPN = 'JPN';
export const CURRENCY_INR = 'INR';
export const CURRENCY_DKK = 'DKK';
export const CURRENCY_HKD = 'HKD';
export const CURRENCY_SGD = 'SGD';

export const CURRENCY_SYMBOL = {
  [CURRENCY_USD]: '$',
  [CURRENCY_EUR]: '€',
  [CURRENCY_JPN]: '¥',
  [CURRENCY_INR]: '₹',
  [CURRENCY_DKK]: 'kr',
  [CURRENCY_HKD]: 'HK$',
  [CURRENCY_SGD]: 'S$',
};
